export const LightningIcon = () => {
  return (
    <svg
      width="59"
      height="59"
      viewBox="0 0 59 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4.71631"
        y="4.53345"
        width="49.85"
        height="49.85"
        rx="24.925"
        fill="#F4EBFF"
      />
      <rect
        x="4.71631"
        y="4.53345"
        width="49.85"
        height="49.85"
        rx="24.925"
        stroke="#F9F5FF"
        strokeWidth="8.30833"
      />
      <path
        d="M30.6799 19.073L20.2944 31.5355H29.6413L28.6028 39.8438L38.9882 27.3813H29.6413L30.6799 19.073Z"
        stroke="#8A2BE2"
        strokeWidth="2.07708"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

